var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Prop } from 'vue-property-decorator';
let ActionsMenu = class ActionsMenu extends Vue {
    // #endregion
    // #region @Refs
    // #endregion
    // #region Class properties
    // #endregion
    // #region Lifecycle Hooks
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    // #endregion
    // #region Async methods (api calls only)
    // #endregion
    // #region Getters & Setters
    get visibleActions() {
        if (!this.actions) {
            return [];
        }
        return this.actions.filter((action) => action.visible);
    }
    get hasVisibleActions() {
        if (!this.actions) {
            return false;
        }
        return this.visibleActions.some((action) => action.visible);
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", Array)
], ActionsMenu.prototype, "actions", void 0);
__decorate([
    Prop({ default: '#9b9b9b' }),
    __metadata("design:type", String)
], ActionsMenu.prototype, "backgroundColor", void 0);
__decorate([
    Prop({ default: '#008ac4' }),
    __metadata("design:type", String)
], ActionsMenu.prototype, "hoverBackgroundColor", void 0);
ActionsMenu = __decorate([
    Component({})
], ActionsMenu);
export default ActionsMenu;
// #endregion
// #region Constants
// #endregion
